import classNames from "classnames";
import AscLink from "../../AscLink/AscLink";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscPrizesCard.module.scss";
import CupIllustration from "../../../assets/illustrations/cup.svg";

export interface AscPrizesCardProps {
  title: string;
  prizes: string[];
  className?: string;
  loading?: boolean;
}

export default function AscPrizesCard({
  title,
  prizes,
  className,
  loading = false,
}: AscPrizesCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
      title={title}
      coverImageUrl={CupIllustration}
      loading={loading}
      imageClassName={styles.coverImage}
      data-testid="asc-prizes-card"
    >
      {prizes?.map((prize, id) => (
        <AscLink className={styles.linkWrapper} key={id} href={undefined} innerWrapperTag="button">
          <div className={styles.linkItem}>
            <div className={styles.linkTitle}>{prize}</div>
          </div>
        </AscLink>
      ))}
    </AscGenericCard>
  );
}
